import { afterNextRender, Component, inject, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-privacy-policy-page',
  template: ``,
  styles: [],
  standalone: false,
})
export class PrivacyPolicyPageComponent {
  platformId = inject(PLATFORM_ID);

  constructor() {
    afterNextRender(() => {
      window.location.href = `${environment.appUrl}/assets/documents/Politique_de_confidentialité.pdf`;
    });
  }
}
